<div class="main-page">

    <nav class="navbar navbar-expand-lg navbar-light bg-light header">

      <!-- <a class="navbar-brand" routerLink="/select-criteria"> <span class="nav-divnk time" ><i class="fa fa-long-arrow-left" style="font-size:48px;color:#fff;margin-top:-16px;"></i></span></a> -->
        <!-- <div class="form-inline my-2 my-lg-0">
          <span class="nav-divnk">Make Payment</span>
      </div> -->

	  <div class="logo"><a (click)="redirect()"><img src="assets/logo-4.png"></a></div>


    </nav>



    <div class="container">
      <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
      <div class="base-payment-page">
	    <div class="base-payment-page-inner">
        <div class="container1">
          <div ></div>
          <div ></div>
          <div class="active"></div>
          <div></div>
        </div>
        <h4>Subscription Checkout</h4>
        <p>Subscribe to this plan for {{plan.caption}}</p>
        <div class="row plan-name">

          <div class="price-cust col-md-4">
            <p>${{plan.price}}</p>
          </div>
          <div class="des-h col-md-8 float-right" >
            <p>{{plan.description}}</p>
          </div>
        </div>

        <div *ngIf="invalidError" style="color:red">
          {{ invalidError.message }}
        </div>
        <form #checkout="ngForm" (ngSubmit)="onSubmit(checkout)" class="checkout">
          <div class="form-row">
            <!-- <label for="card-info">Card Info</label> -->
            <div class="card">
			  <div class="row">
			 <div class="col-md-9">
              <div  #cardInfo></div>
			  </div>
			  <div class="col-md-3">
              <button type="submit" class="btn btn-primary mb-2 add-card-buttom">Add Card</button>
			   </div>
            </div>

			</div>


            <div class="coupen">
              <form class=""  [formGroup]="form" (ngSubmit)="applyCoupon(form.value)">
			   <div class="row">
			    <div class="col-sm-12 col-md-9">
                <div class="any-coupen ">
                  <label for="inputPassword2" class="sr-only">Apply Coupen Code</label>
                  <input formControlName="couponId" type="text" class="form-control" id="" placeholder="Apply Coupen Code">
                </div>
				 </div>
				<div class="col-sm-12 col-md-3">
                <button type="submit" class="btn btn-primary mb-2">Apply</button>
				  </div>
             </div>
            </form>

            </div>
            <br>
            <div class=" card-list" style="width: 100%; padding: 15px 0px;">


              <div *ngFor="let item of cards">
			   <div class=" row">
			    <div class=" col-md-4">
                  <a style="    padding: 4px 0px; display: inline-block;">XXXX-XXXX-XXXX-{{ item.last4 }}</a>
			     </div>
			  <div class=" col-md-3">
                <button  type="submit"  *ngIf="item.id == defaultCard" class="btn btn-primary mb-2">
                  Default
                </button>
                <button
                  *ngIf="item.id != defaultCard"
                  (click)="setDefault(item.id)"
                  class="btn btn-primary mb-2"
                >
                  Make Default
                </button>
				</div>
				 <div class=" col-md-2">
                <a (click)="removeCard(item.id)"><i class="del fa fa-trash" style="    font-size: 22px;    padding: 8px 10px;" aria-hidden="true"></i></a>
				</div>
                 <div class=" col-md-3"></div>



				</div>
              </div>
              </div>
          </div>



          <div class=" text-style recurring-text">
            <p>
              Recurring billing.Cancel anytime.
              By hitting Pay, you will be charged a one time payment for the duration of the
              selected subscription. Subscriptions automatically renew unless canceled in
              "My Subscription" at list 24-hours prior to the end of the Current subscription periods.<br>
            </p>
            <p class="term" ><a href="https://ravel.faith/policies/ravel-terms/" target="_blank"><b>Terms of Services</b> </a><span> and </span><a
                href="https://ravel.faith/policies/privacy-policy/" target="_blank"><b>Private Policy</b></a>
				</p>
          </div>
        </form>

          <div class="pay-button">
            <button type="submit" class="btn btn-primary mb-2 button-c" (click)="requestPayment(cardId)">Pay ${{plan.price}}</button>
          </div>

          </div>
	   </div>

    </div>
  </div>
